import cn from 'classnames'

import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'
import {
  getKeyInitiativeStatusTranslationKey,
  normalizeKeyInitiativeStatus,
  STATUS_OPTIONS,
} from 'partner360/entities/keyInitiatives/model/status'

import styles from './InitiativeStatusBadge.module.scss'

export const InitiativeStatusBadge = ({
  status,
  count,
  compact = false,
}: {
  status?: string | null
  count?: number
  compact?: boolean
}) => {
  if (!status) return null
  const statusKey = normalizeKeyInitiativeStatus(status)
  const color = STATUS_OPTIONS.find((option) => option.key === statusKey)?.color
  const translationKey = getKeyInitiativeStatusTranslationKey(statusKey)
  return (
    <Tooltip inline tipContent={() => <Translation text={translationKey} span />}>
      <span
        className={cn(styles.root, {
          [styles.colored]: Boolean(color),
          [styles.compact]: compact,
        })}
        style={color ? { backgroundColor: color } : undefined}
      >
        <span className={styles.dot} />
        {count != null && <span>{count}</span>}
        <Translation text={translationKey} span />
      </span>
    </Tooltip>
  )
}
